import CartChoosePlanPageV2 from './CartChoosePlanPageV2'

export default CartChoosePlanPageV2
// eslint-disable-next-line import/export
export * from './CartChoosePlanPageV2'
